export const uniqueForms = (data) => {
  return [...new Set(data.map((item) => item.form))];
};

export const formatTime = (milliseconds) => {
  const seconds = Math.floor(milliseconds / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (days > 0) {
    return `(${days}d )`;
  } else if (hours > 0) {
    return ` (${hours}hr )`;
  } else if (minutes > 0) {
    return `${seconds}s (${minutes}min )`;
  } else {
    return `${seconds}s (0min )`;
  }
};


export const timeDiffer = (previousTime) => {
  const storedTimestamp = new Date(previousTime);
  const currentTime = new Date();

  const timeDifferenceInMillis = currentTime - storedTimestamp;
  return formatTime(timeDifferenceInMillis); // Math.floor(timeDifferenceInMillis / 1000);
};

export const dateAndTimeFormat = (timeStamp) => {
  let objectDate = new Date(timeStamp);
  let day = objectDate.getDate();

  let month = objectDate.getMonth();

  let year = objectDate.getFullYear();
  return day + "/" + (month + 1) + "/" + year;
};
export const findTime = (isoDateString) =>{
    const date = new Date(isoDateString);
  
    // Extract date components
    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const year = date.getUTCFullYear();
  
    // Extract time components
    let hours = date.getUTCHours();
    const minutes = String(date.getUTCMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'pm' : 'am';
    
    // Convert 24-hour format to 12-hour format
    hours = hours % 12;
    hours = hours ? hours : 12; // The hour '0' should be '12'
    const formattedHours = String(hours).padStart(2, '0');
  
    return `${day}/${month}/${year} at ${formattedHours}:${minutes} ${ampm}`;
  
}